import api, { unwrap } from './client';

export async function listProgressForOrder(orderId) {
  return unwrap(await api.get(`/progress/orders/${orderId}`));
}

export async function myProgress() {
  return unwrap(await api.get('/progress/me'));
}

export async function createProgress(orderId, formData) {
  // formData is a FormData instance with optional `file` + scalar fields.
  return unwrap(await api.post(`/progress/orders/${orderId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
}

export async function fetchProgressFile(id) {
  const res = await api.get(`/progress/${id}/file`, { responseType: 'blob' });
  return res.data;
}

export async function deleteProgress(id) {
  return unwrap(await api.delete(`/progress/${id}`));
}
